import {salesChannelRegister} from "./salesChannelRegister";
import lang from '../assets/lang/v1';

import lang_BB from '../assets/lang/v1_BB';
import lang_PB from '../assets/lang/v1_PB';
import lang_YL from '../assets/lang/v1_YL';

class langRegister {

    //static file = salesChannelRegister.get('name') === 'propertybooster'?lang_PB:lang_BB;
    static language = "en";

    static getItem(view, item, lang){

        let file = {};

        if(salesChannelRegister.get('name') === 'propertybooster'){
            file = lang_PB;
        }else if(salesChannelRegister.get('name') === 'boostabostad'){
            file = lang_BB;
        }else if(salesChannelRegister.get('name') === 'yieldlock'){
            file = lang_YL;
        }else{
            file = lang_PB;
        }

        try {
            let language = "";
            if(!lang){
                language = langRegister.language;
                try{
                    if(sessionStorage.getItem("language")){
                        language = sessionStorage.getItem("language");
                    }
                }catch (e) {}
            }else{
                language = lang;
            }
            if(file[view][item][language]){
                return file[view][item][language];
            }else{
                return "-";
            }
        }catch (error) {
            return "-";
        }
    }

    static setLanguage(lang){
        langRegister.language = lang;
        try {
            sessionStorage.setItem("language", lang);
        }catch (e) {}
    }

    static getLanguage(){
        try{
            if(sessionStorage.getItem("language")){
                return  sessionStorage.getItem("language");
            }else{
                return langRegister.language;
            }
        }catch (e) {
            return langRegister.language;
        }
    }

    //SHORTENER
    static get(view, item, lang){
        return langRegister.getItem(view, item, lang);
    }

    static set(lang){
        langRegister.setLanguage(lang);
    }

    static lang(){
        return langRegister.getLanguage();
    }

}

export {langRegister}


// WEBPACK FOOTER //
// ./src/services/langRegister.js